var _excluded = ["children", "placeholder", "value"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Select as MuiSelect, styled } from '@mui/material';
import { MenuItem } from '../Menu';
import { jsx as _jsx } from "react/jsx-runtime";
var SELECT_PLACEHOLDER_KEY = 'PLACEHOLDER';
var PlaceholderMenuItem = styled(MenuItem, {
  label: 'MnrlSelect-placeholderMenuItem '
})({
  display: 'none'
});
var PlaceholderMenuItemText = styled('span', {
  label: 'MnrlSelect-placeholderMenuItemText '
})(function (_ref) {
  var theme = _ref.theme;
  return theme.mixins.placeholder;
});
export var getPropsWithPlaceholder = function getPropsWithPlaceholder(_ref2) {
  var children = _ref2.children,
      placeholder = _ref2.placeholder,
      value = _ref2.value,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return _extends({}, restProps, {
    children: [/*#__PURE__*/_jsx(PlaceholderMenuItem, {
      disabled: true,
      value: SELECT_PLACEHOLDER_KEY,
      children: /*#__PURE__*/_jsx(PlaceholderMenuItemText, {
        children: placeholder
      })
    }, SELECT_PLACEHOLDER_KEY)].concat(React.Children.toArray(children)),
    value: value === '' ? SELECT_PLACEHOLDER_KEY : value
  });
};
export var Select = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      _native = props["native"],
      placeholder = props.placeholder;
  return /*#__PURE__*/_jsx(MuiSelect, _extends({}, children && placeholder && !_native ? getPropsWithPlaceholder(props) : props, {
    ref: ref
  }));
});